import React from 'react'
import { Node } from 'reactflow'
import { BaseNodeData } from '../../base/types'
import { NodeTypes } from '../../../../../../shared/models/rule-node'
import { FormProvider, useForm } from 'react-hook-form'
import { Col, Form, Row } from 'react-bootstrap'
import Input from '../../../../../../components/form/Input'
import 'ace-builds/src-noconflict/mode-golang'
import 'ace-builds/src-noconflict/theme-monokai'
import 'ace-builds/src-noconflict/ext-language_tools'

interface ExternalSendEmailFormProps {
  onSubmit: (
    data: Node<BaseNodeData<never>, NodeTypes.EXTERNAL_SEND_EMAIL>
  ) => void
  defaultValues?: Node<BaseNodeData<never>, NodeTypes.EXTERNAL_SEND_EMAIL>
}

const ExternalSendEmailForm = ({
  onSubmit,
  defaultValues,
}: ExternalSendEmailFormProps) => {
  const form = useForm<
    Node<BaseNodeData<never>, NodeTypes.EXTERNAL_SEND_EMAIL>
  >({
    defaultValues,
  })
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = form

  return (
    <FormProvider {...form}>
      <Form noValidate onSubmit={handleSubmit(onSubmit)} id={'form_rule_node'}>
        <Row className={''}>
          <Form.Group as={Col} lg={6} md={12}>
            <Input
              register={register('data.name', {
                required: 'Le nom est obligatoire',
              })}
              label={'Nom'}
              error={errors?.data?.name}
            />
          </Form.Group>
        </Row>
      </Form>
    </FormProvider>
  )
}

export default ExternalSendEmailForm
